import OrderService from "../../services/OrderService";
import TrackingService from "../../services/tracking/TrackingService";
import Router from "preact-router";
import { getMerchandise } from "./merchandiseActions";
export const CLEAR_ORDER = "CLEAR_ORDER";

export const GET_ORDER_REQ_REQUEST = "GET_ORDER_REQ_REQUEST";
export const GET_ORDER_REQ_SUCCESS = "GET_ORDER_REQ_SUCCESS";
export const GET_ORDER_REQ_ERROR = "GET_ORDER_REQ_ERROR";

export const SAVE_ORDER_DATA_REQUEST = "SAVE_ORDER_DATA_REQUEST";
export const SAVE_ORDER_DATA_SUCCESS = "SAVE_ORDER_DATA_SUCCESS";
export const SAVE_ORDER_DATA_ERROR = "SAVE_ORDER_DATA_ERROR";

export const PAYMENT_CLICKED = "PAYMENT_CLICKED";
export const CHECKOUT_ERROR = "CHECKOUT_ERROR";

export const PAYMENT_REQUEST = "PAYMENT_REQUEST";
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
export const PAYMENT_ERROR = "PAYMENT_ERROR";

export const AUTH_KEY_REQUEST = "AUTH_KEY_REQUEST";
export const AUTH_KEY_SUCCESS = "AUTH_KEY_SUCCESS";
export const AUTH_KEY_ERROR = "AUTH_KEY_ERROR";

export const GET_ORDER_REQUEST = "GET_ORDER_REQUEST";
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";
export const GET_ORDER_ERROR = "GET_ORDER_ERROR";

export const GET_DUMMY_ORDER_LOADING = "GET_DUMMY_ORDER_LOADING";
export const GET_DUMMY_ORDER_SUCCESS = "GET_DUMMY_ORDER_SUCCESS";
export const GET_DUMMY_ORDER_ERROR = "GET_DUMMY_ORDER_ERROR";

export const ADD_DISCOUNT_REQUEST = "ADD_DISCOUNT_REQUEST";
export const ADD_DISCOUNT_SUCCESS = "ADD_DISCOUNT_SUCCESS";
export const ADD_DISCOUNT_ERROR = "ADD_DISCOUNT_ERROR";

export const REMOVE_DISCOUNT_REQUEST = "REMOVE_DISCOUNT_REQUEST";
export const REMOVE_DISCOUNT_SUCCESS = "REMOVE_DISCOUNT_SUCCESS";
export const REMOVE_DISCOUNT_ERROR = "REMOVE_DISCOUNT_ERROR";

export const ADD_GIFT_CARD_REQUEST = "ADD_GIFT_CARD_REQUEST";
export const ADD_GIFT_CARD_SUCCESS = "ADD_GIFT_CARD_SUCCESS";
export const ADD_GIFT_CARD_ERROR = "ADD_GIFT_CARD_ERROR";

export const COMPLETE_GIFT_CARD_ORDER_REQUEST =
  "COMPLETE_GIFT_CARD_ORDER_REQUEST";
export const COMPLETE_GIFT_CARD_ORDER_ERROR = "COMPLETE_GIFT_CARD_ORDER_ERROR";
export const COMPLETE_GIFT_CARD_ORDER_SUCCESS =
  "COMPLETE_GIFT_CARD_ORDER_SUCCESS";

export const REMOVE_GIFT_CARD_REQUEST = "REMOVE_GIFT_CARD_REQUEST";
export const REMOVE_GIFT_CARD_SUCCESS = "REMOVE_GIFT_CARD_SUCCESS";
export const REMOVE_GIFT_CARD_ERROR = "REMOVE_GIFT_CARD_ERROR";

export const TIME_EXPIRED = "TIME_EXPIRED";

export const CHANGE_PAYMENT_METHOD = "CHANGE_PAYMENT_METHOD";

export const CREDIT_AND_DEBIT = "CREDIT_AND_DEBIT";
export const INVOICING = "INVOICING";

export const QUANTITY_VALIDATION_ERROR = "QUANTITY_VALIDATION_ERROR";
export const QUANTITY_VALIDATION_REQUEST = "QUANTITY_VALIDATION_REQUEST";

import { loadSummary } from "./orderSummaryActions";

export const timeExpired = () => {
  return dispatch => {
    dispatch({ type: TIME_EXPIRED });
  };
};

export const clearOrder = () => {
  return dispatch => {
    dispatch({ type: CLEAR_ORDER });
  };
};

export const payByCreditDebit = () => {
  return dispatch => {
    dispatch({ type: CHANGE_PAYMENT_METHOD, method: CREDIT_AND_DEBIT });
  };
};

export const payByInvoice = () => {
  return dispatch => {
    dispatch({ type: CHANGE_PAYMENT_METHOD, method: INVOICING });
  };
};

export const getOrder = (id, getMerch = false) => {
  return dispatch => {
    dispatch({ type: GET_ORDER_REQUEST, id });
    OrderService.get(id)
      .then(order => {
        dispatch({ type: GET_ORDER_SUCCESS, order });
        if (getMerch) {
          getMerchandise(id)(dispatch);
        }
      })
      .catch(err => {
        dispatch({ type: GET_ORDER_ERROR, error: err });
      });
  };
};

export const getOrderPublic = (eventId, orderId, token) => {
  return async dispatch => {
    try {
      dispatch({ type: GET_ORDER_REQUEST });
      const order = await OrderService.getPublicOrder(eventId, orderId, token);
      dispatch({ type: GET_ORDER_SUCCESS, order });
    } catch (err) {
      dispatch({ type: GET_ORDER_ERROR, error: err });
    }
  };
};

export const saveOrderPublic = (eventId, orderId, token, orderData) => {
  return async dispatch => {
    try {
      dispatch({ type: SAVE_ORDER_DATA_REQUEST });
      const order = await OrderService.savePublicOrder(
        eventId,
        orderId,
        token,
        orderData
      );
      dispatch({ type: SAVE_ORDER_DATA_SUCCESS, order });
    } catch (err) {
      dispatch({ type: SAVE_ORDER_DATA_ERROR, error: err });
    }
  };
};

export const addDiscount = (eventId, orderId, discountCode) => {
  return (dispatch, getState) => {
    dispatch({ type: ADD_DISCOUNT_REQUEST });
    OrderService.addDiscount(eventId, orderId, discountCode)
      .then(result => {
        dispatch({ type: ADD_DISCOUNT_SUCCESS, order: result.order });
        const state = getState();
        loadSummary(
          state.event.id,
          state.ticketSelection.requestedTickets,
          state.ticketSelection.clientDonation,
          result.order,
          state.merchandise.merch.display || []
        )(dispatch);
      })
      .catch(err => {
        const error =
          err && err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : err;
        dispatch({ type: ADD_DISCOUNT_ERROR, error });
      });
  };
};

export const removeDiscount = orderId => {
  return (dispatch, getState) => {
    dispatch({ type: REMOVE_DISCOUNT_REQUEST });
    OrderService.removeDiscount(orderId)
      .then(result => {
        dispatch({ type: REMOVE_DISCOUNT_SUCCESS, order: result.order });
        const state = getState();
        loadSummary(
          state.event.id,
          state.ticketSelection.requestedTickets,
          state.ticketSelection.clientDonation,
          result.order,
          state.merchandise.merch.display || []
        )(dispatch);
      })
      .catch(err => {
        const error =
          err && err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : err;
        dispatch({ type: REMOVE_DISCOUNT_ERROR, error });
      });
  };
};

export const completeGiftCardOrder = orderId => {
  return (dispatch, getState) => {
    dispatch({ type: COMPLETE_GIFT_CARD_ORDER_REQUEST });
    OrderService.completeOrderWithGiftCard(orderId)
      .then(result => {
        dispatch({
          type: COMPLETE_GIFT_CARD_ORDER_SUCCESS,
          order: result.order
        });
        const state = getState();
        orderComplete(
          state.event.data.slug,
          state.event.data,
          state.order.data,
          false,
          false
        );
      })
      .catch(err => {
        const error =
          err && err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : err;
        dispatch({ type: COMPLETE_GIFT_CARD_ORDER_ERROR, error });
      });
  };
};

export const addGiftCard = (eventId, orderId, giftCardCode) => {
  return (dispatch, getState) => {
    dispatch({ type: ADD_GIFT_CARD_REQUEST });
    OrderService.addGiftCard(eventId, orderId, giftCardCode)
      .then(result => {
        dispatch({
          type: ADD_GIFT_CARD_SUCCESS,
          order: result.order,
          isFullPayment: result.isFullPayment
        });
        const state = getState();
        loadSummary(
          state.event.id,
          state.ticketSelection.requestedTickets,
          state.ticketSelection.clientDonation,
          result.order
        )(dispatch);
      })
      .catch(err => {
        const error =
          err && err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : err;
        dispatch({ type: ADD_GIFT_CARD_ERROR, error });
      });
  };
};

export const removeGiftCard = orderId => {
  return (dispatch, getState) => {
    dispatch({ type: REMOVE_GIFT_CARD_REQUEST });
    OrderService.removeGiftCard(orderId)
      .then(result => {
        dispatch({ type: REMOVE_GIFT_CARD_SUCCESS, order: result.order });
        const state = getState();
        loadSummary(
          state.event.id,
          state.ticketSelection.requestedTickets,
          state.ticketSelection.clientDonation,
          result.order
        )(dispatch);
      })
      .catch(err => {
        const error =
          err && err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : err;
        dispatch({ type: REMOVE_GIFT_CARD_ERROR, error });
      });
  };
};

export const generateDummyOrder = event => {
  let ticketTypes = event.data.ticketTypes.map((ticket, index) => {
    ticket.ticketTypeName = ticket.name;
    ticket.ticketTypeId = ticket._id;
    ticket.order = index + 1;
    return ticket;
  });
  return dispatch => {
    dispatch({ type: GET_DUMMY_ORDER_LOADING });
    const dummyOrder = {
      timeExpired: false,
      data: {
        createdAt: new Date().getTime(),
        incompleteAt: new Date().getTime() + 10000000,
        tickets: ticketTypes
      }
    };
    dispatch({ type: GET_DUMMY_ORDER_SUCCESS, order: dummyOrder });
  };
};

export const requestOrder = (
  slug,
  id,
  eventDateId,
  requestedItems,
  discountCode,
  clientDonation,
  lastOrderId,
  isGlobal,
  manualOrderValues
) => {
  return (dispatch, getState) => {
    dispatch({ type: GET_ORDER_REQ_REQUEST });
    OrderService.request(
      id,
      eventDateId,
      requestedItems,
      discountCode,
      clientDonation,
      lastOrderId,
      isGlobal,
      manualOrderValues
    )
      .then(result => {
        const state = getState();
        const order = result.order;
        const additionalQuestions = result.additionalQuestions || false;
        dispatch({
          type: GET_ORDER_REQ_SUCCESS,
          order,
          additionalQuestions
        });
        if (isGlobal) {
          Router.route(`/gift-cards/${slug}/details/${order._id}`);
        } else if (result.offerMerch) {
          Router.route(`/${slug}/add-ons/${order._id}`);
        } else {
          Router.route(`/${slug}/details/${order._id}`);
        }
        if (!isGlobal) {
          loadSummary(
            state.event.id,
            state.ticketSelection.requestedTickets,
            state.ticketSelection.clientDonation,
            order
          )(dispatch);
          TrackingService.ticketsAdded(state.event.data, order);
        }
      })
      .catch(err => {
        const error =
          err && err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : err;
        dispatch({ type: GET_ORDER_REQ_ERROR, error });
      });
  };
};

export const saveOrderData = (
  slug,
  eventId,
  orderData,
  tickets,
  ticketData,
  hasAdditionalSteps,
  isGlobal
) => {
  return (dispatch, getState) => {
    dispatch({ type: SAVE_ORDER_DATA_REQUEST });
    OrderService.saveDetails(
      orderData,
      tickets,
      ticketData,
      hasAdditionalSteps,
      isGlobal
    )
      .then(result => {
        const order = result.order;
        const authKey = result.authKey;
        dispatch({ type: SAVE_ORDER_DATA_SUCCESS, order, authKey });
        const state = getState();
        TrackingService.enteredDetails(state.event.data, order);
        if (order.status === "complete") {
          // the order is complete show thank you
          orderComplete(slug, state.event.data, order, hasAdditionalSteps);
        } else {
          if (isGlobal) {
            const { giftCardsOrder, giftCardPage } = state.giftCards;
            loadSummary(
              giftCardPage.userId,
              [],
              0,
              {},
              [],
              giftCardsOrder,
              false
            )(dispatch);
          } else {
            loadSummary(
              state.event.id,
              state.ticketSelection.tickets,
              state.ticketSelection.clientDonation,
              order,
              state.merchandise.merch.display || []
            )(dispatch);
          }
          if (
            hasAdditionalSteps &&
            state.event.data.settings.enableTicketAssigning
          ) {
            Router.route(`/${slug}/assign/${order._id}`);
          } else if (hasAdditionalSteps) {
            redirectToSeatingReservation(slug, order._id);
          } else {
            // the order is not complete payment is needed
            Router.route(
              `${isGlobal ? "/gift-cards" : ""}/${slug}/payment/${order._id}`
            );
          }
        }
      })
      .catch(err => {
        console.error(err);
        const error =
          err && err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : err;
        const additionalQuestionQuantityError =
          err &&
          err.response &&
          err.response.data &&
          err.response.data.error &&
          err.response.data.error.additionalQuestionQuantityError
            ? err.response.data.error.additionalQuestionQuantityError
            : false;
        dispatch({
          type: SAVE_ORDER_DATA_ERROR,
          error,
          additionalQuestionQuantityError
        });
      });
  };
};

const redirectToSeatingReservation = (eventSlug, orderId) => {
  Router.route(`/${eventSlug}/seatingmap/${orderId}`);
};

export const saveAfterCheckoutQuestions = (
  event,
  order,
  orderData,
  ticketData
) => {
  const tickets = order.data.tickets;
  return dispatch => {
    OrderService.saveAfterCheckoutQuestions(
      event.data._id,
      orderData,
      tickets,
      ticketData
    )
      .then(result => {
        Router.route(`/${event.data.slug}/complete/${order.data._id}`);
        TrackingService.complete(event.data, order.data);
      })
      .catch(err => {
        const error =
          err && err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : err;
        const additionalQuestionQuantityError =
          err &&
          err.response &&
          err.response.data &&
          err.response.data.error &&
          err.response.data.error.additionalQuestionQuantityError
            ? err.response.data.error.additionalQuestionQuantityError
            : false;
        dispatch({
          type: SAVE_ORDER_DATA_ERROR,
          error,
          additionalQuestionQuantityError
        });
      });
  };
};

export const payClicked = () => {
  return dispatch => {
    dispatch({ type: PAYMENT_CLICKED });
  };
};

export const checkoutError = () => {
  return dispatch => {
    dispatch({ type: CHECKOUT_ERROR });
  };
};

export const orderComplete = (
  eventSlug,
  event,
  order,
  hasAdditionalSteps,
  isGlobal
) => {
  let afterCheckoutQuestions =
    event && event.additionalQuestions
      ? event.additionalQuestions.filter(q => q.askAfterCheckout)
      : [];
  let newAfterCheckoutQuestions = [];
  order.tickets.forEach(ticket => {
    afterCheckoutQuestions.forEach(q => {
      if (
        !q.appliesTo ||
        !q.appliesTo.length ||
        q.appliesTo.indexOf(ticket.ticketTypeId) !== -1
      ) {
        newAfterCheckoutQuestions.push(q);
      }
    });
  });

  if (hasAdditionalSteps) {
    redirectToSeatingReservation(eventSlug, order._id);
  } else if (hasAdditionalSteps && event.settings.enableTicketAssigning) {
    Router.route(`/${eventSlug}/assign/${order._id}`);
  } else if (newAfterCheckoutQuestions && newAfterCheckoutQuestions.length) {
    Router.route(`/${eventSlug}/afterCheckout/${order._id}`);
  } else {
    Router.route(
      `${isGlobal ? "/gift-cards" : ""}/${eventSlug}/complete/${order._id}`
    );
  }
  TrackingService.complete(event, order);
};

export const redirectToComplete = (eventSlug, event, order) => {
  return dispatch => {
    Router.route(`/${eventSlug}/complete/${order._id}`);
  };
};

export const pay = (eventSlug, orderId, gateway, details, id, isGlobal) => {
  return (dispatch, getState) => {
    dispatch({ type: PAYMENT_REQUEST });
    OrderService.pay(orderId, gateway, details, id, isGlobal)
      .then(result => {
        const order = result.order;
        if (result.success && order.status === "complete") {
          // the order is complete show thank you
          const state = getState();
          orderComplete(eventSlug, state.event.data, order, false, isGlobal);
          dispatch({ type: PAYMENT_SUCCESS, order });
          return;
        }
        dispatch({ type: PAYMENT_ERROR, order, error: result.error });
      })
      .catch(err => {
        const error =
          err && err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : err;
        dispatch({ type: PAYMENT_ERROR, error });
      });
  };
};
